// TODO: 文件命名改造
export enum FormatType {
  Date = 1,
  Amount,
  Duration,
  Link
}

// 数据类型-业务
export enum DataType {
  MusicInfo = 'musicInfo',
  ModifiableText = 'modifiableText',
  SortSource = 'sortSource'
}

// 数据取值类型 Static-静态的，走api接口获取 Dynamic-动态的，需要通过url传递实时数据
export enum DataGetType {
  Static,
  Dynamic
}
export interface MutableText {
  id: string;
  content: string;
  start: number;
  duration: number;
}

export interface MusicClipDetailItem {
  id: number;
  music_title: string;
  music_artist: string;
}
export interface DetailItem {
  label: string;
  readKey: string;
  key: string;
  value: string | MutableText[] | boolean;
  type?: FormatType | DataType;
  getType?: DataGetType;
}

// 数据取值模式
export enum DataGetMode {
  Static = '0', // 纯静态-走api接口 获取的数据是实时的
  Dynamic = '1', // 纯动态-通过url参数传值 传递的数据是抓取时的数据
  StaticAndDynamic = '2' // 动静结合-对于不会变的数据走api接口，动态变化的数据走url传参
}

/** debug平台 */
export const detailList: DetailItem[] = [
  {
    label: 'Template Id',
    readKey: 'web_id',
    key: 'id',
    value: '',
    getType: DataGetType.Dynamic,
  },
  {
    label: 'Sort Source',
    readKey: 'is_operation_boost',
    key: 'sortSource',
    value: '',
    type: DataType.SortSource,
    getType: DataGetType.Dynamic,
  },
  {
    label: 'Creator Name',
    readKey: 'author.name',
    key: 'authorName',
    value: '',
    getType: DataGetType.Static,
  },
  {
    label: 'Creator UID',
    readKey: 'author.uid',
    key: 'authorUid',
    value: '',
    getType: DataGetType.Static,
  },
  {
    label: 'Title',
    readKey: 'short_title',
    key: 'title',
    value: '',
    getType: DataGetType.Static,
  },
  {
    label: 'Description',
    readKey: 'title',
    key: 'desc',
    value: '',
    getType: DataGetType.Static,
  },
  {
    label: 'Template Post Date',
    readKey: 'create_time',
    key: 'createTime',
    value: '',
    type: FormatType.Date,
    getType: DataGetType.Static,
  },
  {
    label: 'Framents',
    readKey: 'fragment_count',
    key: 'fragmentCount',
    value: '',
    getType: DataGetType.Static,
  },
  {
    label: 'Actual Replaceable Fragment',
    readKey: 'mutable_fragments_length',
    key: 'mutableFragmentLength',
    value: '',
    getType: DataGetType.Static,
  },
  {
    label: 'Duration',
    readKey: 'duration',
    key: 'duration',
    value: '',
    type: FormatType.Duration,
    getType: DataGetType.Static,
  },
  {
    label: 'Play',
    readKey: 'play_amount',
    key: 'playAmount',
    value: '',
    type: FormatType.Amount,
    getType: DataGetType.Dynamic,
  },
  {
    label: 'Usage',
    readKey: 'usage_amount',
    key: 'usageAmount',
    value: '',
    type: FormatType.Amount,
    getType: DataGetType.Dynamic,
  },
  {
    label: 'Export',
    readKey: 'export_amount',
    key: 'exportAmount',
    value: '',
    type: FormatType.Amount,
    getType: DataGetType.Dynamic,
  },
  {
    label: 'Share',
    readKey: 'share_amount',
    key: 'shareAmount',
    value: '',
    type: FormatType.Amount,
    getType: DataGetType.Dynamic,
  },
  {
    label: 'Template Link',
    readKey: 'web_id',
    key: 'templateUrl',
    value: '',
    type: FormatType.Link,
    getType: DataGetType.Static,
  },
  {
    label: 'Video Link',
    readKey: 'video_url',
    key: 'videoUrl',
    value: '',
    getType: DataGetType.Static,
  },
  {
    label: 'Modifiable Text',
    readKey: 'mutable_texts',
    key: 'mutableTextList',
    value: [],
    type: DataType.ModifiableText,
    getType: DataGetType.Static,
  },
];

/** bpo平台与tcs平台 */
export const newDetailList: DetailItem[] = [
  {
    label: 'Template Id',
    readKey: 'web_id',
    key: 'id',
    value: '',
    getType: DataGetType.Dynamic,
  },
  {
    label: 'Creator Name',
    readKey: 'author.name',
    key: 'authorName',
    value: '',
    getType: DataGetType.Static,
  },
  {
    label: 'Title',
    readKey: 'short_title',
    key: 'title',
    value: '',
    getType: DataGetType.Static,
  },
  {
    label: 'Description',
    readKey: 'title',
    key: 'desc',
    value: '',
    getType: DataGetType.Static,
  },
  // {
  //   label: 'Music Title',
  //   readKey: 'music_title',
  //   key: 'music_title',
  //   value: '',
  //   getType: DataGetType.Dynamic,
  // },
  // {
  //   label: 'Music Artist',
  //   readKey: 'music_artist',
  //   key: 'music_artist',
  //   value: '',
  //   getType: DataGetType.Dynamic,
  // },
  {
    label: 'Music Info',
    readKey: 'music_clip_detail',
    key: 'musicClipDetail',
    value: [],
    type: DataType.MusicInfo,
    getType: DataGetType.Static,
  },
  {
    label: 'Template Post Date',
    readKey: 'create_time',
    key: 'createTime',
    value: '',
    type: FormatType.Date,
    getType: DataGetType.Static,
  },
  {
    label: 'Framents',
    readKey: 'fragment_count',
    key: 'fragmentCount',
    value: '',
    getType: DataGetType.Static,
  },
  {
    label: 'Actual Replaceable Fragment',
    readKey: 'mutable_fragments_length',
    key: 'mutableFragmentLength',
    value: '',
    getType: DataGetType.Static,
  },
  {
    label: 'Duration',
    readKey: 'duration',
    key: 'duration',
    value: '',
    type: FormatType.Duration,
    getType: DataGetType.Static,
  },
  {
    label: 'Template Link',
    readKey: 'web_id',
    key: 'templateUrl',
    value: '',
    type: FormatType.Link,
    getType: DataGetType.Static,
  },
  {
    label: 'Modifiable Text',
    readKey: 'mutable_texts',
    key: 'mutableTextList',
    value: [],
    type: DataType.ModifiableText,
    getType: DataGetType.Static,
  },
  {
    label: 'Video Link',
    readKey: 'video_url',
    key: 'videoUrl',
    value: '',
    getType: DataGetType.Static,
  },
];
